'use strict';

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays a Loading Indicator with pure css.
 *
 */
const Loading = ({type = "dots", alt = "Loading..."}) => {
    return (
        <div className={'loader' + ' ' + type} aria-live="polite" aria-busy="true">
            {alt}
        </div>
    );
};

Loading.propTypes = {
    // the type of loading indicator to have, options currently are "spinner" and "dots"
    type: PropTypes.oneOf(["spinner", "spinner2", "spinner-small", "dots"]),
    // Messaging for screen reader while loading is happening
    alt: PropTypes.string
};

export default Loading;
